<button
  #trigger
  type="button"
  class="lang-select-trigger"
  (click)="toggle()"
  [attr.aria-label]="ariaLabel"
  aria-haspopup="listbox"
  [attr.aria-expanded]="open"
  [disabled]="disabled"
>
  <svg *ngIf="variant === 'compact'" class="lang-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
  <span class="lang-label">{{ variant === 'compact' ? (selected | uppercase) : selectedLabel }}</span>
  <svg class="chevron" [class.open]="open" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
</button>

<ul class="lang-menu" *ngIf="open" role="listbox">
  <li
    *ngFor="let lang of languages"
    role="option"
    [attr.aria-selected]="lang.code === selected"
    class="lang-option"
    [class.active]="lang.code === selected"
    (click)="select(lang.code)"
  >
    <span>{{ lang.label }}</span>
    <svg *ngIf="lang.code === selected" class="check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  </li>
</ul>
